import { render, staticRenderFns } from "./ApproverModal.vue?vue&type=template&id=e65be202&scoped=true"
import script from "./ApproverModal.vue?vue&type=script&lang=js"
export * from "./ApproverModal.vue?vue&type=script&lang=js"
import style0 from "./ApproverModal.vue?vue&type=style&index=0&id=e65be202&prod&lang=scss&scoped=true"
import style1 from "./ApproverModal.vue?vue&type=style&index=1&id=e65be202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65be202",
  null
  
)

export default component.exports